import { render, staticRenderFns } from "./HcStatistic.vue?vue&type=template&id=dec4c650"
import script from "./HcStatistic.vue?vue&type=script&lang=js"
export * from "./HcStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports